import React from "react";
import styled from "styled-components";
import { Container } from "reactstrap";
import MediaQuery from "react-responsive";
import DesktopView from "./DesktopView";
import MobileView from "./MobileView";

const DetailPage = styled(Container)`
  margin: 0 0;
  width: 100%;
  max-width: 100%;

  padding-right: 0px;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  @media (min-width: 992px) {
    padding-top: unset;
  }
  @media (min-width: 576px) {
    .container {
      max-width: 100%;
    }
  }
`;
const PageWrapper = styled.div`
  background-color: ${(props) => props.bgColor || "white"};
`;

export default ({ job }) => {
  const data = { job };
  return (
    <PageWrapper>
      <DetailPage>
        <MediaQuery minWidth={992}>
          <DesktopView {...{ data }} />
        </MediaQuery>
        <MediaQuery maxWidth={991}>
          <MobileView {...{ data }} />
        </MediaQuery>
      </DetailPage>
    </PageWrapper>
  );
};
